let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4gYcM")).then(() => parcelRequire('hg3w4'));